export default __webpack_public_path__ + "static/media/flat.7fbff361.png";